import { render, staticRenderFns } from "./SerialCard.vue?vue&type=template&id=0a197a3c&scoped=true&"
import script from "./SerialCard.vue?vue&type=script&lang=ts&"
export * from "./SerialCard.vue?vue&type=script&lang=ts&"
import style0 from "./SerialCard.vue?vue&type=style&index=0&id=0a197a3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a197a3c",
  null
  
)

export default component.exports